import ComplianceHistory from './ComplianceHistory'

export default ComplianceHistory
